const normalizeAuditTaskText = (...parts) => parts
  .flat()
  .filter(Boolean)
  .map((part) => String(part)
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' '))
  .filter(Boolean)
  .join(' ');

const EXCLUDED_AUDIT_TASK_KEYWORDS = [
  'training',
  'it audit',
  'information technology audit',
  'cmf'
];

// Word-boundary regex per keyword — a naive `haystack.includes(keyword)` false-positives
// whenever two unrelated words happen to be adjacent, e.g. description "...auditMethodology=
// Single Audit" joined with wording "Audit Scheduling..." forms "...single audit audit
// scheduling...", which contains the raw substring "it audit" (tail of one "audit" + the next
// "audit") even though no field actually says "IT Audit". \b anchors ensure "it" only matches
// as its own word, not mid-word inside "audit".
const EXCLUDED_AUDIT_TASK_PATTERNS = EXCLUDED_AUDIT_TASK_KEYWORDS.map(
  (keyword) => new RegExp(`\\b${keyword.replace(/\s+/g, '\\s+')}\\b`)
);

export const isExcludedAuditTaskEntry = (entry) => {
  const haystack = normalizeAuditTaskText(
    entry?.taskType,
    entry?.taskTypeCode,
    entry?.taskTitle,
    entry?.title,
    entry?.description,
    entry?.wording,
    entry?.label,
    entry?.code,
    entry?.serviceName,
    entry?.serviceItem,
    entry?.serviceItemName,
    entry?.standardName,
    entry?.productCategoryName,
    entry?.__serviceContext?.serviceName
  );

  return EXCLUDED_AUDIT_TASK_PATTERNS.some((pattern) => pattern.test(haystack));
};

export const filterExcludedAuditTasks = (entries = []) => (
  Array.isArray(entries) ? entries.filter((entry) => !isExcludedAuditTaskEntry(entry)) : []
);

const resolveConvertedProjectId = async (api, conversionResponse, leadId) => {
  const directProjectId = Number(
    conversionResponse?.projectId ||
    conversionResponse?.id ||
    conversionResponse?.project?.id ||
    0
  );

  if (directProjectId > 0) {
    return directProjectId;
  }

  if (!leadId) {
    return null;
  }

  const projectRes = await api.get(`/crm/projects/detail/lead/${leadId}`);
  const resolvedProjectId = Number(projectRes?.data?.id || 0);

  return resolvedProjectId > 0 ? resolvedProjectId : null;
};

export const primeConvertedProjectAuditTasks = async (api, conversionResponse, leadId) => {
  const projectId = await resolveConvertedProjectId(api, conversionResponse, leadId);

  if (!projectId) {
    return null;
  }

  await api.get('/audit/tasks', { params: { projectId } });

  return projectId;
};
